/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: "us-west-2",
    aws_appsync_graphqlEndpoint: "https://nrhbfuxtmbeqdceiubk35k7pm4.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_eDNxzdQWH",
    aws_user_pools_web_client_id: "4soeqgifkngs5967bbsc5nobl9",
    aws_cognito_identity_pool_id: "us-west-2:956df814-7ddf-47a9-9c49-05b459f1c39a",
    Auth: {
        region: "us-west-2",
        userPoolId: "us-west-2_eDNxzdQWH",
        userPoolWebClientId: "4soeqgifkngs5967bbsc5nobl9",
        identityPoolId: "us-west-2:956df814-7ddf-47a9-9c49-05b459f1c39a",
    },
    Storage: {
        AWSS3: {
            bucket: "reliance-crm-data-artifacts-prod",
            region: "us-west-2",
        },
    },
    mandatorySignIn: true,
    oauth: {
        domain: "prod.auth.reliancelitigation.com",
        scope: ["email", "profile", "openid"],
        redirectSignIn: "https://data.reliancelitigation.com/",
        redirectSignOut: "https://data.reliancelitigation.com/",
        responseType: "code",
    },
};

export default awsmobile;
